export interface ConfigurationInfo {

  sensitive: boolean;
  type: string;
  value: string[];
  key: string;
  uuid: string;

}
